var PendingEvent = (function () {
    function PendingEvent(action, request) {
        this.myAction = action;
        this.myRequest = request;
    }
    Object.defineProperty(PendingEvent.prototype, "action", {
        get: function () {
            return this.myAction;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PendingEvent.prototype, "request", {
        get: function () {
            return this.myRequest;
        },
        enumerable: false,
        configurable: true
    });
    return PendingEvent;
}());
export { PendingEvent };
